export default "__VITE_ASSET__c11583bf__"